import { render, staticRenderFns } from "./dilu-uploadfileA.vue?vue&type=template&id=73e2dfad&scoped=true&"
import script from "./dilu-uploadfileA.vue?vue&type=script&lang=js&"
export * from "./dilu-uploadfileA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e2dfad",
  null
  
)

export default component.exports